import './playerArondTable.css';
import React, { useContext, useEffect } from 'react';
import RoomProvider from 'components/Provider/RoomProvider';
import GodfatherBox from 'components/GodfatherBox/GodfatherBox';
import StatusMessage from 'components/StatusMessage/StatusMessage';
import StartGame from 'components/StartGame/StartGame';
import JoinInvite from 'components/JoinInvite/JoinInvite';
import RoleDesc from 'components/RoleDesc/RoleDesc';
import PlayerProfile from 'components/PlayerProfile/PlayerProfile';
import PlayerItem from './PlayerItem';
import WinnerBoard from 'components/WinnerBoard/WinnerBoard';
import gameData from 'others/game/gameData';

function GfBoxContent({ room }){
    if(room.status == 'EndOfGame'){
        return <WinnerBoard />
    }

    if (room.isMyTurn || room.memorizeGfBox) {
        return <>
                    <GodfatherBox />
                    { room.status == 'Debate' && <PlayerProfile /> }
                </>
    }

    if(room.localPlayer?.role) {
        return <>
                    <RoleDesc role={room.localPlayer?.role} />
                    <PlayerProfile />
                </>
    }
    
    if (room.status != 'Debate' && !room.memorizeGfBox){
        return  <StatusMessage>
                    { gameData.data?.isRoomMaster && (room.status == 'WaitingForPlayers' || room.status == 'ReadyToStart') &&
                        <>
                            <JoinInvite />
                            <StartGame />
                        </>
                    }
                </StatusMessage>
    }
    
    return <></>
}

function PlayersArondTable() {
    const { room } = useContext(RoomProvider);
    const players = room?.players;

    useEffect(()=>{
    }, [gameData.data])

    return (
        <div id='pa_mainContainer'>
            <div id="pa_itemList">
                <div id='pa_infoContainer'>
                    { (room.isMyTurn || room.status == 'Debate' || room.status == 'EndOfGame' || room.memorizeGfBox || room.localPlayer?.role) && 
                            <StatusMessage /> }
                </div>
                <div id="pa_godfatherBox">
                    { <GfBoxContent room={room} /> }                    
                </div>
                { 
                    players?.map((item, i)=><PlayerItem 
                                                player={item} 
                                                index={i} 
                                                isRoomMaster={item.name == gameData.data?.roomMasterName}
                                                key={i} 
                                            />) 
                }
            </div>
            
        </div>
    );
}


export default PlayersArondTable;